import React, { useCallback, useEffect } from 'react';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import { withTransition } from '~/ui/transition/Transition';
import { Overlay } from '~/ui/overlay/Overlay';
import { OpenThumbsMenuButton } from './OpenThumbsButton';
import { FeedbackPositive } from './feedback/FeedbackPositive';
import { FeedbackNegative } from './feedback/FeedbackNegative';
import { Root } from './Root';
import { ThumbsPages, useThumbsStore } from './Store';
import { useOpenCloseAudioEffect } from '~/ui/audio-effect/useOpenCloseAudioEffect';
import { ThankScreen } from './feedback/ThankScreen';

const SettingsUI = () => {
  const { open, toggle, page, llamaVariant, setLlamaVariant } =
    useThumbsStore();
  const OverlayWithTransition = withTransition(Overlay);
  useOpenCloseAudioEffect(open);

  const escFunction = useCallback(event => {
    if (event.keyCode === 27) {
      toggle(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', escFunction);

    return () => {
      document.removeEventListener('keydown', escFunction);
    };
  }, [escFunction]);

  const rootEl = document.getElementById('root');

  useEffect(() => {
    if (rootEl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rootEl.inert! = open;
    }
  }, [open]);

  useEffect(() => {
    if (rootEl) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      rootEl.inert! = false;
    }
  }, []);

  useEffect(
    () =>
      setLlamaVariant(
        page === ThumbsPages.FeedbackNegative ? 'sad' : 'default'
      ),
    [page]
  );

  return (
    <>
      <OpenThumbsMenuButton />
      <OverlayWithTransition
        show={open}
        open={open}
        onClick={() => toggle(false)}
      >
        <LlamaModal
          variant={llamaVariant}
          horizontal="right"
          vertical="center"
          close={() => toggle(false)}
        >
          <Root />
          <FeedbackPositive />
          <FeedbackNegative />
          <ThankScreen />
        </LlamaModal>
      </OverlayWithTransition>
    </>
  );
};

export const Thumbs = () => (
  <>
    <SettingsUI />
  </>
);
